// Skills v2 — one hook, one source of truth for an agent's Quality & Improve
// surface (A4). Fetches the aggregated /skills/quality-summary payload (quality
// signals + per-skill health + improvement proposals + air-gap consolidation
// availability) in a SINGLE request, and exposes a reload() so mutations
// (approve/undo/attach) refresh everything consistently. Both the on-agent
// Overview and the library "Quality & Improve" tab consume this.
import { useState, useEffect, useCallback } from "react";
import { skillsApi } from "../api/client";

function unwrapObj(res) {
  if (res && res.data && typeof res.data === "object" && !Array.isArray(res.data)) return res.data;
  return res || null;
}

export function useAgentSkills(agentId) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const reload = useCallback(async () => {
    if (!agentId) return;
    setLoading(true);
    setError(null);
    try {
      setData(unwrapObj(await skillsApi.qualitySummary(agentId)));
    } catch {
      setError("Couldn't load quality for this agent.");
    } finally {
      setLoading(false);
    }
  }, [agentId]);

  useEffect(() => { reload(); }, [reload]);

  return { data, loading, error, reload };
}
